import React, { useState, useEffect } from 'react';
import './InstallPWA.css';

const InstallPWA = () => {
    const [showPrompt, setShowPrompt] = useState(false);

    useEffect(() => {
        // Detect iOS
        const isIos = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());

        // Detect if already in standalone mode (installed)
        const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator.standalone);

        // Check if user has dismissed the prompt previously
        const hasDismissed = localStorage.getItem('pwa_prompt_dismissed');

        if (isIos && !isInStandaloneMode && !hasDismissed) {
            // Delay showing to not overwhelm immediately on load
            const timer = setTimeout(() => {
                setShowPrompt(true);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleDismiss = () => {
        setShowPrompt(false);
        localStorage.setItem('pwa_prompt_dismissed', 'true');
    };

    if (!showPrompt) return null;

    return (
        <div className="install-pwa-modal">
            <div className="install-header">
                <div className="header-content">
                    <img src="/logo192.png" alt="NovaInk" className="app-icon" />
                    <div className="text-group">
                        <h3 className="install-title">Instale o NovaInk</h3>
                        <p className="install-subtitle">Adicione à sua tela de início para a melhor experiência.</p>
                    </div>
                </div>
                <button className="close-btn" onClick={handleDismiss}>&times;</button>
            </div>

            <div className="instructions-list">
                <div className="instruction-step">
                    <span className="step-number">1</span>
                    <span>
                        Toque no botão <strong>Compartilhar</strong>
                        <span className="action-icon">
                            <svg className="share-icon-svg" viewBox="0 0 24 24">
                                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                <polyline points="16 6 12 2 8 6" />
                                <line x1="12" y1="2" x2="12" y2="15" />
                            </svg>
                        </span>
                        na barra inferior.
                    </span>
                </div>
                <div className="instruction-step">
                    <span className="step-number">2</span>
                    <span>
                        Role para baixo e toque em <strong>"Adicionar à Tela de Início"</strong>
                        <span className="action-icon">
                            <svg className="plus-icon-svg" viewBox="0 0 24 24">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                <line x1="12" y1="8" x2="12" y2="16" />
                                <line x1="8" y1="12" x2="16" y2="12" />
                            </svg>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default InstallPWA;
